import React, { useEffect, useState } from "react";
import { axios } from "../../../../../Global";
import { setAppError, setBreadCrumb } from "../../../../../store/userSlice";
import { useDispatch, useSelector } from "react-redux";
import {
  Link,
  Outlet,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";
import PromptElement from "../../../PromptElement";
import ListDataCostSheet from "./ListDataCostSheet";
import CostSheetSteps from "../QuotationCostSheet/CostSheetSteps";
import { CgSpinner } from "react-icons/cg";
import { CiEdit } from "react-icons/ci";
import { AiOutlineFilePdf } from "react-icons/ai";
import { SiMicrosoftexcel } from "react-icons/si";
import { printValidationError } from "../../../../../utils/functions";
import { checkAccessFn } from "../../../../../utils/checkAccess";
import Loading from "../../../../../ReusableComponents/Loading/Loading";
import MonthlyQuotation from "./MonthlyQuotationTemplate/MonthlyQuotation";
import GenerateQuotaion from "./GenerateQuotaion";
import { PDFViewer, ReactPDF, PDFDownloadLink } from "@react-pdf/renderer";
import CostPlusPdf from "./CostSheetPdf/CostPlusPdf";
import HourlyExcel from "../../../DummyPdfs/HourlyExcel/HourlyExcell";
import { hourlyExcelData } from "../../../DummyPdfs/dummyData";
import monthlyExcel from "../../../DummyPdfs/MonthlyExcel/MonthlyExcel";
import HeadingEdit from "./HeadingEdit";
import GenerateCostPlusPDFPopup from "./CostSheetPdf/GenerateCostPlusPDFPopup";
import HeadingEditCostPlus from "./HeadingEditCostPlus";
import SettingsPopup from "../../../../../ReusableComponents/SettingsPopup/SettingsPopup";
import { IoSettingsOutline } from "react-icons/io5";

export default function QuotationCostSheet() {
  const InitialSelectedTItles = [
    {
      col: "Actual Profession",
      title: "actual_profession",
    },
    {
      col: "Visa Profession",
      title: "visa_profession",
    },
    {
      col: "Profession Level",
      title: "profession_level",
    },
    {
      col: "Gender",
      title: "gender",
    },
    {
      col: "Nationality",
      title: "nationality",
    },
    {
      col: "Quantity",
      title: "quantity",
    },
    {
      col: "Basic",
      title: "basic",
    },
    {
      col: "Food",
      title: "food",
    },

    {
      col: "Total Monthly Per Head Cost",
      title: "total_monthly_cost_head",
    },
  ];
  const [showPromptElement, setShowPromptElement] = useState({
    open: false,
    id: null,
  });
  const [openHeadingEditPupup, setOpenHeadingEditPopup] = useState(false);
  const token = localStorage.getItem("token");

  const dashboardData = useSelector((state) => state.dashboardData);

  const [openGenerateQuotation, setOpenGenerateQuotation] = useState(false);

  const [generatedTitles, setGeneratedTitles] = useState(InitialSelectedTItles);

  const [TableRowLists, setTableRowLists] = useState([]);

  const checkAccess = (module, name) => {
    return checkAccessFn(dashboardData, module, name);
  };

  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [loading, setLoading] = useState({
    edit: false,
    delete: false,
    listData: false,
    loadingId: "",
  });
  const [list, setList] = useState([]);

  const [costSheetForm, setCostSheetForm] = useState({
    open: false,
    quotationId: null,
    costSheetId: null,
    method: null,
  });

  const [quotationType, setQuotationType] = useState("");
  const [getUpdatedData, setGetUpdatedData] = useState(false);

  const currentQuotationId =
    location.state?.quotationId || location.pathname.split("/")[3];
  let currentMethod = location.state?.method || "View";
  let quotationNumber = location.state?.quotationNumber || "COST SHEET";

  useEffect(() => {
    if (currentMethod === "View") {
      if (
        !["notes", "terms", "create"].includes(
          location.pathname.split("/").at(-1)
        )
      ) {
        dispatch(
          setBreadCrumb([
            { label: "QUOTATION", link: "/dashboard/quotation" },
            {
              label: String(
                list?.quotation?.quotation_number || "COST SHEETS"
              )?.toUpperCase(),
              link: `/dashboard/quotation/${currentQuotationId}`,
            },
          ])
        );
      }
    }
  }, [list, location.pathname, currentMethod, location.state]);

  useEffect(() => {
    if (currentMethod === "View") {
      axios
        .get(`/dashboard/quotation-cost-sheet-module/${currentQuotationId}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => {
          setList(res.data.data);
          if (costSheetForm.method !== "Edit") {
            setCostSheetForm((p) => ({ ...p, open: false }));
          }
        })
        .catch((err) => {
          navigate("/dashboard/quotation");
          if (err.response?.data?.message) {
            dispatch(
              setAppError({
                msg: err.response?.data?.message,
              })
            );
          }
        });
    } else if (currentMethod === "Create") {
      setCostSheetForm((p) => ({
        ...p,
        quotationId: currentQuotationId,
        open: true,
        method: "Create",
      }));
      axios
        .get(`/dashboard/quotation/${currentQuotationId}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => {
          const quotDetails = res.data.data;
          setQuotationType(quotDetails?.quotation_type?.name || "");
        })
        .catch((err) => {
          dispatch(
            setAppError({
              msg: err.message,
            })
          );
        });
    }
  }, [
    getUpdatedData,
    loading.delete,
    location.pathname,
    currentMethod,
    costSheetForm.method,
  ]);

  const editData = async (costSheetId, type = "EmployeeSalaryPackage") => {
    if (type === "Fees&Muqeem") {
      navigate(`/dashboard/quotation/${currentQuotationId}/edit-fees-muqeem`, {
        state: { method: "Edit", type },
      });
    } else {
      navigate(
        `/dashboard/quotation/${currentQuotationId}/edit/${costSheetId}`,
        {
          state: { method: "Edit", type, hourType: list?.quotation?.hour_type },
        }
      );
    }
    if (costSheetId) {
      setCostSheetForm((p) => ({
        ...p,
        costSheetId: costSheetId,
        method: "Edit",
        open: true,
      }));
    }
  };
  const deleteData = async (id) => {
    if (id) {
      if (list?.quotation_cost_sheet?.length <= 1) {
        currentMethod = "Delete";
      }
      try {
        const response = await axios.delete(
          `/dashboard/quotation-cost-sheet-module/${id}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        if (response.status === 200) {
          dispatch(
            setAppError({
              msg: response.data.message,
              color: "success",
            })
          );

          if (list?.quotation_cost_sheet?.length <= 1) {
            navigate("/dashboard/quotation");
          } else {
            setGetUpdatedData((prev) => !prev);
          }
        }
      } catch (err) {
        setLoading((p) => ({ ...p, delete: false }));
        dispatch(
          setAppError({
            msg: err.message,
          })
        );
        if (err?.response?.status === 403) {
          if (err?.response?.data?.message) {
            dispatch(
              setAppError({
                msg: err?.response?.data.message,
              })
            );
          }
        }
      }
    }
  };

  const [pdfDownloadLoading, setPdfDownloadLoading] = useState({
    state: true,
    item: "",
  });

  const [createNewSection, setCreateNewSection] = useState(false);
  useEffect(() => {
    if (
      location.pathname.split("/").at(-1) === "create" ||
      "edit-fees-muqeem"
    ) {
      setCreateNewSection(true);
    }
    if (location.pathname.split("/").at(-1) === "terms") {
      setCreateNewSection(true);
    }
    if (location.pathname.split("/").at(-1) === "notes") {
      setCreateNewSection(true);
    }
  }, [location]);

  useEffect(() => {
    if (
      !["create", "terms", "notes", "edit-fees-muqeem"].includes(
        location.pathname.split("/").at(-1)
      )
    ) {
      setCreateNewSection(false);
    }
    if (!["edit"].includes(location.pathname.split("/").at(-2))) {
      setCostSheetForm((p) => ({ ...p, open: false }));
    }
    if (!costSheetForm.open) {
      if (["edit"].includes(location.pathname.split("/").at(-2))) {
        navigate(`/dashboard/quotation/${currentQuotationId}`);
      }
    }
  }, [location]);

  console.log(list, "list");

  const pdfDetailsGeneration = () => {
    let tableArrays = [];
    let tableRowData = {};
    let basicInfo = list?.quotation_cost_sheet_basic_info;
    let costSheetDetails = list?.quotation_cost_sheet_cost_details;
    let costSheetHeading = list?.quotation_cost_sheet_heading;
    basicInfo?.forEach((item) => {
      let salary = item?.salary;
      let monthlyFee = item?.monthly_fee;
      tableRowData.actual_profession = item?.job_position?.name;

      tableRowData.new_field = " ";
      tableRowData.gender = item?.gender;
      tableRowData.visa_profession = item?.visa_profession?.name;
      tableRowData.profession_level = item?.profession_level?.name;
      tableRowData.quantity = item?.quantity;
      tableRowData.nationality = item?.nationality?.name;
      let costSheetTotalCost = 0;
      let totalEmployeeCost = 0;
      let totalGovernmentCost = 0;
      let totalSoundlineCost = 0;
      costSheetDetails?.forEach((cost) => {
        if (
          cost?.quotation_cost_sheet_profession_basic_information_id == item.id
        ) {
          costSheetHeading?.forEach((heading, headIndex) => {
            if (cost?.quotation_cost_sheet_heading_id == heading?.id) {
              if (heading?.rate_category_id == 1) {
                totalEmployeeCost += Number(cost?.cost);
              }
              if (heading?.rate_category_id == 2) {
                totalGovernmentCost += Number(cost?.cost);
              }
              if (heading?.rate_category_id == 3) {
                totalSoundlineCost += Number(cost?.cost);
              }

              costSheetTotalCost =
                Number(costSheetTotalCost) + Number(cost?.cost);
              // basic
              if (heading?.type == "Default") {
                tableRowData[
                  String(heading?.rate_category_item?.name)
                    .trim()
                    .split(" ")
                    .join("_")
                    .toLowerCase()
                ] = cost?.cost;
              } else if (heading?.type == "Dynamic") {
                tableRowData[
                  String(heading?.rate_category_item_name)
                    .trim()
                    .split(" ")
                    .join("_")
                    .toLowerCase()
                ] = cost?.cost;
              }
            }
          });
        }
      });

      tableRowData.total_monthly_cost_head = costSheetTotalCost;
      console.log("..............costSheetTotalCost....",costSheetTotalCost,list)
      if (list?.quotation_type) {
        tableRowData.per_hour_rate = Number(
          Number(costSheetTotalCost) / 26 / Number(list?.quotation?.hour_type)
        ).toFixed(2);
      }

      tableRowData.total_employee_salary_package =
        Number(totalEmployeeCost).toFixed(2);
      tableRowData.total_government_fees =
        Number(totalGovernmentCost).toFixed(2);
      tableRowData.total_soundline_fees = Number(totalSoundlineCost).toFixed(2);

      tableRowData.total_monthly_cost_head =
        Number(costSheetTotalCost).toFixed(2);
      tableArrays.push(tableRowData);
      tableRowData = {};
    });
    setTableRowLists(tableArrays);
  };

  useEffect(() => {
    pdfDetailsGeneration();
  }, [list]);

  const [showSettings, setShowSettings] = useState(false);
  const [defaultFields, setDefaultFields] = useState([
    {
      id: 1,
      title: "Actual Profession",
      value: "job_position.name",
      width: "min-w-[12rem]",
      default: true,
    },
    {
      id: 2,
      title: "VISA Profession",
      value: "visa_profession.name",
      width: "min-w-[10rem]",
      default: true,
    },
    {
      id: 3,
      title: "Quantity",
      value: "quantity",
      width: "min-w-[8rem]",
      default: true,
    },
    {
      id: 4,
      title: "Profession Level",
      value: "profession_level.name",
      width: "min-w-[10rem]",
    },

    {
      id: 5,
      title: "Nationality",
      value: "nationality.name",
      width: "min-w-[10rem]",
    },

    {
      id: 6,
      title: "Gender",
      value: "gender",
      width: "min-w-[8rem]",
    },
    {
      id: 7,
      title: "Created At",
      value: "created_at",
      width: "min-w-[8rem]",
      type: "longDate",
    },
    {
      id: 8,
      title: "Total - Employee Salary Package",
      value: "1",
      width: "min-w-[12rem]",
      type: "totalSectionCost",
    },
    {
      id: 9,
      title: "Total - GOVERNMENT FEES",
      value: "2",
      width: "min-w-[12rem]",
      type: "totalSectionCost",
    },
    {
      id: 10,
      title: "Total - SOUNDLINE FEES",
      value: "3",
      width: "min-w-[12rem]",
      type: "totalSectionCost",
    },
    {
      id: 11,
      title: "Total Monthly Per Head Cost",
      value: "",
      width: "min-w-[12rem]",
      type: "totalCost",
    },
  ]);

  useEffect(() => {
    if (list?.quotation_type == "Cost Plus") {
      setDefaultFields((prevState) =>
        prevState.filter((data) => ![8, 9, 10].includes(data.id))
      );
    }
  }, [list]);

  const [selectedFields, setSelectedFields] = useState(
    defaultFields.filter((data) => data.default)
  );

  useEffect(() => {
    if (list?.quotation_cost_sheet_heading?.length > 0) {
      const allHeadings = list?.quotation_cost_sheet_heading?.map((heading) => {
        const headingTitle =
          heading?.rate_category_item?.name || heading?.rate_category_item_name;
        return {
          id: heading?.id,
          title: headingTitle,
          width: String(headingTitle)
            .split(" ")
            .find((title) => title.length > 10)
            ? "min-w-[12rem]"
            : "min-w-[8rem]",
          type: heading?.type,
        };
      });
      console.log(allHeadings, "all heading");

      // Filter out duplicates based on id and merge with existing setDefaultFields
      setDefaultFields((prevState) => {
        const uniqueHeadings = allHeadings.filter((heading) => {
          return !prevState.some(
            (prevHeading) => prevHeading.id === heading.id
          );
        });

        return [...prevState, ...uniqueHeadings];
      });
    }
  }, [list]);

  return (
    <>
      {openHeadingEditPupup && list?.quotation_type !== "Cost Plus" && (
        <HeadingEdit
          showPromptElement={openHeadingEditPupup}
          setShowPromptElement={setOpenHeadingEditPopup}
          quotDetails={list}
          setGetUpdatedData={setGetUpdatedData}
        />
      )}
      {openHeadingEditPupup && list?.quotation_type === "Cost Plus" && (
        <HeadingEditCostPlus
          showPromptElement={openHeadingEditPupup}
          setShowPromptElement={setOpenHeadingEditPopup}
          quotDetails={list}
          setGetUpdatedData={setGetUpdatedData}
        />
      )}
      {openGenerateQuotation && list?.quotation_type !== "Cost Plus" && (
        <GenerateQuotaion
          InitialSelectedTItles={InitialSelectedTItles}
          setGeneratedTitles={setGeneratedTitles}
          openGenerateQuotation={openGenerateQuotation}
          setOpenGenerateQuotation={setOpenGenerateQuotation}
          list={list}
          TableRowLists={TableRowLists}
        />
      )}
      {openGenerateQuotation && list?.quotation_type === "Cost Plus" && (
        <GenerateCostPlusPDFPopup
          InitialSelectedTItles={InitialSelectedTItles}
          setGeneratedTitles={setGeneratedTitles}
          openGenerateQuotation={openGenerateQuotation}
          setOpenGenerateQuotation={setOpenGenerateQuotation}
          list={list}
          TableRowLists={TableRowLists}
        />
      )}
      {showPromptElement.open && (
        <PromptElement
          showPromptElement={showPromptElement}
          setShowPromptElement={setShowPromptElement}
          deleteHandler={deleteData}
        />
      )}

      {showSettings && (
        <SettingsPopup
          showPopup={showSettings}
          setShowPopup={setShowSettings}
          initialState={defaultFields}
          finalState={selectedFields}
          setFinalState={setSelectedFields}
        />
      )}

      {!createNewSection ? (
        <div className="p-2  sm:p-5">
          {!costSheetForm.open && (
            <>
              <CostSheetStep1Field
                govtFee={list?.quotation_rate_category?.government_fee_type}
                salaryAllowance={
                  list?.quotation_rate_category?.salary_and_allowance_fee_type
                }
                slaFees={list?.quotation_rate_category?.soundline_fee_type}
                quotationId={currentQuotationId}
                quotationDetails={{
                  number: list?.quotation?.quotation_number,
                  name: list?.quotation?.name,
                  type: list?.quotation_type,
                  clientName: list?.client,
                  clientSpecific: list?.quotation?.client?.client_specific,
                  status: list?.quotation?.status,
                  rejected_reason:
                    list?.quotation?.status === "Rejected" &&
                    list?.quotation?.rejected_reason,
                  statusDate:
                    list?.quotation?.status === "Approved"
                      ? list?.quotation?.approved_date
                      : list?.quotation?.status === "Rejected" &&
                        list?.quotation?.rejected_date,
                }}
              />
              <div className="flex flex-wrap items-stretch text-xs-ultra sm:text-xs justify-between px-6 gap-3 mt-10">
                <div
                  className={
                    list?.length <= 0
                      ? "flex gap-3 items-start opacity-50"
                      : "flex gap-3 items-start"
                  }
                >
                  {checkAccess("Quotation", "quotation-cost-sheet-create") &&
                    list?.quotation_type === "Cost Plus" && (
                      <Link
                        to={`create`}
                        state={{
                          costSheetState: {
                            govtFee:
                              list?.quotation_type === "Cost Plus"
                                ? "onetime_cost"
                                : "monthly_cost",
                            salaryAllowance: "monthly_cost",
                            slaFees: "monthly_cost",
                          },
                          quotationId: currentQuotationId,
                          quotationDetails: {
                            number: list?.quotation?.quotation_number,
                            name: list?.quotation?.name,
                            type: list?.quotation_type,
                            clientName: list?.client,
                            clientSpecific:
                              list?.quotation?.client?.client_specific,
                            status: list?.quotation?.status,
                            statusDate:
                              list?.quotation?.status === "Approved"
                                ? list?.quotation?.approved_date
                                : list?.quotation?.status === "Rejected" &&
                                  list?.quotation?.rejected_date,
                          },
                        }}
                      >
                        <button
                          disabled={list?.length <= 0}
                          className="p-2 bg-red text-white rounded-md "
                        >
                          <p className="flex gap-3 items-center">
                            ADD PROFESSION
                          </p>
                        </button>
                      </Link>
                    )}
                  {checkAccess("Quotation", "quotation-cost-sheet-create") &&
                    list?.quotation_type !== "Cost Plus" && (
                      <Link
                        to={`create`}
                        state={{
                          costSheetState: {
                            govtFee:
                              list?.quotation_type === "Cost Plus"
                                ? "onetime_cost"
                                : "monthly_cost",
                            salaryAllowance: "monthly_cost",
                            slaFees: "monthly_cost",
                          },
                          quotationId: currentQuotationId,
                          quotationDetails: {
                            number: list?.quotation?.quotation_number,
                            name: list?.quotation?.name,
                            type: list?.quotation_type,
                            clientName: list?.client,
                            clientSpecific:
                              list?.quotation?.client?.client_specific,
                            status: list?.quotation?.status,
                            statusDate:
                              list?.quotation?.status === "Approved"
                                ? list?.quotation?.approved_date
                                : list?.quotation?.status === "Rejected" &&
                                  list?.quotation?.rejected_date,
                          },
                        }}
                      >
                        <button
                          disabled={list?.length <= 0}
                          className="p-2 bg-red text-white rounded-md "
                        >
                          <p className="flex gap-3 items-center">
                            ADD PROFESSION
                          </p>
                        </button>
                      </Link>
                    )}
                  {checkAccess("Quotation", "quotation-cost-sheet-list") && (
                    <Link to={`notes`}>
                      <button
                        disabled={list?.length <= 0}
                        className="p-2 bg-blue text-white rounded-md "
                      >
                        <p className="flex gap-3 items-center">Notes</p>
                      </button>
                    </Link>
                  )}

                  {checkAccess("Quotation", "quotation-cost-sheet-list") && (
                    <Link to={`terms`}>
                      <button
                        disabled={list?.length <= 0}
                        className="p-2 bg-blue text-white rounded-md "
                      >
                        <p className="flex gap-3 items-center">
                          TERMS AND CONDITIONS
                        </p>
                      </button>
                    </Link>
                  )}
                  {checkAccess("Quotation", "quotation-cost-sheet-edit") && (
                    <button
                      disabled={list?.length <= 0}
                      onClick={() => setOpenHeadingEditPopup(true)}
                      className="p-2 bg-blue text-white rounded-md "
                    >
                      EDIT HEADING
                    </button>
                  )}

                  {checkAccess("Quotation", "quotation-cost-sheet-edit") &&
                    list?.quotation_type === "Cost Plus" && (
                      <Link
                        to={`edit-fees-muqeem`}
                        state={{
                          costSheetState: {
                            govtFee:
                              list?.quotation_type === "Cost Plus"
                                ? "onetime_cost"
                                : "monthly_cost",
                            salaryAllowance: "monthly_cost",
                            slaFees: "monthly_cost",
                          },
                          quotationId: currentQuotationId,
                          quotationDetails: {
                            number: list?.quotation?.quotation_number,
                            name: list?.quotation?.name,
                            type: list?.quotation_type,
                            clientName: list?.client,
                            clientSpecific:
                              list?.quotation?.client?.client_specific,
                            status: list?.quotation?.status,
                            statusDate:
                              list?.quotation?.status === "Approved"
                                ? list?.quotation?.approved_date
                                : list?.quotation?.status === "Rejected" &&
                                  list?.quotation?.rejected_date,
                          },
                        }}
                      >
                        <button
                          disabled={list?.length <= 0}
                          className="p-2 bg-blue text-white rounded-md "
                        >
                          <p className="flex gap-3 items-center">
                            EDIT FEES PAYABLE AND MUQEEM POINTS
                          </p>
                        </button>
                      </Link>
                    )}
                </div>
                <div
                  className={
                    list?.length <= 0 ? "flex gap-3 opacity-50" : "flex gap-3"
                  }
                >
                  {checkAccess("Quotation", "quotation-cost-sheet-list") && (
                    <>
                      {list?.quotation_type === "Monthly" && (
                        <>
                          <button
                            disabled={list?.length <= 0}
                            className="p-2 px-4 uppercase rounded-md bg-blue text-white min-w-fit h-fit flex items-center gap-2"
                            onClick={() => monthlyExcel(list)}
                          >
                            <p>Download Monthly Excel</p>
                          </button>
                        </>
                      )}
                    </>
                  )}
                  {/* GENERATE QUOTATION */}
                  {checkAccess("Quotation", "quotation-cost-sheet-list") && (
                    <button
                      disabled={list?.length <= 0}
                      onClick={() => setOpenGenerateQuotation(true)}
                      className={
                        list?.length <= 0
                          ? "p-2 bg-blue text-white rounded-md opacity-50"
                          : "p-2 bg-blue text-white rounded-md"
                      }
                    >
                      GENERATE QUOTATION
                    </button>
                  )}

                  {list &&
                    list?.quotation_type === "Hourly" &&
                    checkAccess("Quotation", "quotation-cost-sheet-list") && (
                      <>
                        {/* <button
                          className="p-2 bg-blue text-white rounded-md "
                          onClick={() =>
                            getPDFOrExcel(currentQuotationId, "excel")
                          }
                        >
                          <p className="flex gap-3 items-center">
                            Download Excel
                            {pdfDownloadLoading.state &&
                            pdfDownloadLoading.item === "excel" ? (
                              <CgSpinner className="animate-spin mx-auto" />
                            ) : (
                              <AiOutlineFilePdf />
                            )}
                          </p>
                        </button> */}
                        <button
                          disabled={list?.length <= 0}
                          className="p-2 px-4 uppercase rounded-md bg-blue text-white min-w-fit h-fit flex items-center gap-2"
                          onClick={() => HourlyExcel(list)}
                        >
                          <p>Download Hourly Excel</p>
                        </button>
                      </>
                    )}
                  <button
                    disabled={list?.length <= 0}
                    onClick={() => setShowSettings(true)}
                  >
                    <IoSettingsOutline size={"1.2rem"} />
                  </button>
                </div>
                <p className="text-sm w-full text-right font-medium xl:hidden  block">{`Slide / scroll to right >`}</p>
              </div>
              <ListDataCostSheet
                costDetails={list?.quotation_cost_sheet_cost_details || []}
                costHeadings={list?.quotation_cost_sheet_heading || []}
                list={list?.quotation_cost_sheet_basic_info || []}
                editData={editData}
                deleteData={setShowPromptElement}
                loading={loading}
                setLoading={setLoading}
                quotationName={list?.quotation?.name}
                selectedFields={selectedFields}
                houtType={list?.quotation?.hour_type}
              />
            </>
          )}
          {costSheetForm.open && (
            <CostSheetSteps
              govtFee={list?.quotation_rate_category?.government_fee_type}
              salaryAllowance={
                list?.quotation_rate_category?.salary_and_allowance_fee_type
              }
              slaFees={list?.quotation_rate_category?.soundline_fee_type}
              costSheetForm={costSheetForm}
              updateCostSheetForm={setCostSheetForm}
              quotationType={quotationType}
              quotationDetails={{
                number: list?.quotation?.quotation_number,
                name: list?.quotation?.name,
                type: list?.quotation_type,
                clientName: list?.client,
                clientSpecific: list?.quotation?.client?.client_specific,
                status: list?.quotation?.status,
                statusDate:
                  list?.quotation?.status === "Approved"
                    ? list?.quotation?.approved_date
                    : list?.quotation?.status === "Rejected" &&
                      list?.quotation?.rejected_date,
              }}
            />
          )}
        </div>
      ) : (
        <>
          <Outlet
            context={{ quotationNumber: list?.quotation?.quotation_number }}
          />
        </>
      )}
    </>
  );
}

/// Step 1 Field Component

const CostSheetStep1Field = (props) => {
  const token = localStorage.getItem("token");
  const dispatch = useDispatch();
  const [editing, setEditing] = useState({
    govtFee: false,
    salaryAllowance: false,
    slaFees: false,
    someEdited: false,
  });
  const [submitFormLoading, setSubmitFormLoading] = useState(false);
  const [loading, setLoading] = useState();
  const [govtFee, setGovtFee] = useState(props?.govtFee);
  const [salaryAllowance, setSalaryAllowance] = useState(
    props?.salaryAllowance
  );
  const [slaFees, setSlaFees] = useState(props?.slaFees);

  useEffect(() => {
    setGovtFee(props.govtFee);
    setSalaryAllowance(props.salaryAllowance);
    setSlaFees(props.slaFees);
  }, [props]);

  const submitForm = async (event) => {
    event.preventDefault();
    setSubmitFormLoading(true);
    try {
      const response = await axios.put(
        `/dashboard/quotation-rate-category-update/${props.quotationId}`,
        {
          government_fee_type: govtFee,
          salary_and_allowance_fee_type: salaryAllowance,
          soundline_fee_type: slaFees,
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (response.status === 200) {
        dispatch(
          setAppError({
            msg: response?.data?.message || "Successfully edited.",
            color: "success",
          })
        );
      }
      setSubmitFormLoading(false);
    } catch (error) {
      setSubmitFormLoading(false);
      printValidationError(error, "quotation");
      dispatch(
        setAppError({
          msg: error.message,
        })
      );
    }
  };

  const editField = (field) => {
    setEditing((p) => ({ ...p, someEdited: true }));
    if (field === "govtFee") {
      setEditing((p) => ({ ...p, govtFee: true }));
    }
    if (field === "salaryAllowance") {
      setEditing((p) => ({ ...p, salaryAllowance: true }));
    }
    if (field === "slaFees") {
      setEditing((p) => ({ ...p, slaFees: true }));
    }
  };

  useEffect(() => {
    const number = props?.quotationDetails?.number;
    const type = props?.quotationDetails?.type;
    const name = props?.quotationDetails?.name;
    const clientName = props?.quotationDetails?.clientName;
    if (
      number == undefined ||
      type == undefined ||
      name == undefined ||
      clientName == undefined
    )
      setLoading(true);
    else setLoading(false);
  }, [props]);

  return (
    <center>
      {loading && (
        <div className="max-w-lg lg:max-w-2xl w-full bg-white dark:bg-dark rounded-lg shadow-sm  p-5 flex flex-col  items-center justify-center">
          <Loading />
        </div>
      )}
      {!loading && (
        <div
          className={`max-w-lg lg:max-w-2xl w-full bg-white dark:bg-dark rounded-lg shadow-sm  p-5 flex flex-col  items-start justify-center`}
        >
          <div className=" mx-auto max-w-md">
            <div className="text-left">
              <div className="mb-1 flex items-center">
                <p className="tracking-wide mr-1 font-bold"> QUOTATION NO</p>:{" "}
                <span className="ml-1 font-medium">
                  {props?.quotationDetails?.number}
                </span>
              </div>
              <div className="mb-1 flex items-center">
                <p className="tracking-wide mr-1 font-bold">QUOTATION NAME</p> :{" "}
                <span className="ml-1 font-medium">
                  {props?.quotationDetails?.name}
                </span>
              </div>
              <div className="mb-1 flex items-center">
                <p className="tracking-wide mr-1 font-bold">QUOTATION TYPE</p> :{" "}
                <span className="ml-1 font-medium">
                  {props?.quotationDetails?.type}
                </span>
              </div>
              <div className="mb-1 flex items-center">
                <p className="tracking-wide mr-1 font-bold">CLIENT NAME</p> :{" "}
                <span className="ml-1 font-medium">
                  {props?.quotationDetails?.type === "Cost Plus"
                    ? props?.quotationDetails?.clientName?.name
                    : props?.quotationDetails?.clientName}
                </span>
              </div>
              <div
                className={`mb-1 ${
                  props?.quotationDetails?.clientSpecific?.length < 30
                    ? "flex"
                    : "block"
                }`}
              >
                <p className="tracking-wide mr-1 font-bold min-w-fit">
                  CLIENT SPECIFIC :
                </p>

                <span className="ml-3 font-medium ">
                  {props?.quotationDetails?.clientSpecific}
                </span>
              </div>
              {(props?.quotationDetails?.status === "Approved" ||
                props?.quotationDetails?.status === "Rejected") && (
                <>
                  <div className="mb-1 flex items-center">
                    <p className="tracking-wide mr-1 font-bold">Status</p> :{" "}
                    <span className="ml-1 font-medium">
                      {props?.quotationDetails?.status}
                    </span>
                  </div>
                  <div className="mb-1 flex items-center">
                    <p className="tracking-wide mr-1 font-bold">
                      {props?.quotationDetails?.status} Date
                    </p>{" "}
                    :{" "}
                    <span className="ml-1 font-medium">
                      {props?.quotationDetails?.statusDate}
                    </span>
                  </div>
                  {props?.quotationDetails?.status === "Rejected" && (
                    <div className="mb-1 flex items-center">
                      <p className="tracking-wide mr-1 font-bold">
                        Rejected Reason
                      </p>{" "}
                      :{" "}
                      <span className="ml-1 font-medium">
                        {props?.quotationDetails?.rejected_reason}
                      </span>
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
          {/* <form
          method="POST"
          onSubmit={(event) => submitForm(event)}
          className="w-full  flex flex-col items-center justify-center"
        >
          <div className="flex flex-col p-2 gap-1 w-full max-w-md">
            <label htmlFor={`addOrEdit-govtfee`} className="text-xs text-left">
              Government Fees
            </label>

            <div className="flex gap-3 justify-center items-center w-full ">
              <select
                name="govtFee"
                id={`addOrEdit-govtFee`}
                required
                className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs w-full"
                value={govtFee}
                onChange={(e) => setGovtFee(e.target.value)}
                disabled={!editing.govtFee}
              >
                <option value="onetime">One-time</option>
                <option value="monthly">Monthly</option>
              </select>
              <CiEdit size={"1.3rem"} onClick={() => editField("govtFee")} />
            </div>
          </div>
          <div className="flex flex-col p-2 gap-1 w-full max-w-md">
            <label htmlFor={`addOrEdit-govtfee`} className="text-xs text-left">
              Salary and Allowance
            </label>
            <div className="flex gap-3 justify-center items-center w-full ">
              <select
                name="salaryAllowance"
                id={`addOrEdit-salaryAllowance`}
                required
                className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs w-full"
                value={salaryAllowance}
                onChange={(e) => setSalaryAllowance(e.target.value)}
                disabled={!editing.salaryAllowance}
              >
                <option value="onetime">One-time</option>
                <option value="monthly">Monthly</option>
              </select>
              <CiEdit size={"1.3rem"} onClick={() => editField("salaryAllowance")} />
            </div>
          </div>
          <div className="flex flex-col p-2 gap-1 w-full max-w-md">
            <label htmlFor={`addOrEdit-govtfee`} className="text-xs text-left">
              SLA Fees
            </label>
            <div className="flex gap-3 justify-center items-center w-full ">
              <select
                name="slaFees"
                id={`addOrEdit-slaFees`}
                required
                className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs w-full"
                value={slaFees}
                onChange={(e) => setSlaFees(e.target.value)}
                disabled={!editing.slaFees}
              >
                <option value="onetime">One-time</option>
                <option value="monthly">Monthly</option>
              </select>
              <CiEdit size={"1.3rem"} onClick={() => editField("slaFees")} />
            </div>
          </div>

          <div className={`p-2  w-full max-w-md  gap-3 ${editing.someEdited ? "flex" : "hidden"}`}>
            <button
              className="bg-black dark:bg-red w-full text-xs text-white rounded-md py-2 flex justify-center items-center gap-2"
              type="submit"
              disabled={submitFormLoading}
            >
              <p>Update</p>
              {submitFormLoading && <CgSpinner className="animate-spin" />}
            </button>
            <CiEdit size={"1.3rem"} className="invisible" />
          </div>
        </form> */}
        </div>
      )}
    </center>
  );
};
